/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!***************************************!*\
  !*** ./src/assets/js/share-button.js ***!
  \***************************************/
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var ShareButton = /*#__PURE__*/function () {
  function ShareButton() {
    _classCallCheck(this, ShareButton);
  }

  _createClass(ShareButton, [{
    key: "initShareButton",
    value: function initShareButton() {
      var button = document.querySelector('[data-share-button]');

      if (button) {
        button.addEventListener('click', function () {
          navigator.clipboard.writeText("".concat(window.location.origin).concat(button.getAttribute('value')));
        });
      }
    }
  }]);

  return ShareButton;
}();

var shareButton = new ShareButton();
shareButton.initShareButton();
/******/ })()
;